import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageAll: 1,
  colorAll: 2,
  orderAll: '1'
}

export const pageSlice = createSlice({
  name: 'pageinfo',
  initialState,
  reducers: {
    setPageAll: (state, action) => {
      state.pageAll = action.payload
    },
    setColorAll: (state, action) => {
        state.colorAll = action.payload
    },
    setOrderAll: (state, action) => {
      state.orderAll = action.payload
  },
  },
})

export const { setPageAll, setColorAll, setOrderAll } = pageSlice.actions

export default pageSlice.reducer